
// import {fire, fireAuth} from '@/firebase/config'
import { useStore } from "vuex";
import { onMounted, ref, provide, onUpdated } from "vue";
import { a, n } from "@/composables/types";
import useCss from "@/composables/useCss";
// import { useRouter, useRoute } from "vue-router";

export default {
  // components: [],
  setup() {
    const ss = useStore().state;
    // const sg = useStore().getters;
    ///////////////////////

    ///////////css////////////
    // css import
    const { cqueA, cLenEqual, devAdd } = useCss();

    const openTab = (x: n) => {
      ss.tab = x;
      addEventListener("click", e => {
        const tabs = document.querySelectorAll(".tab");
        tabs.forEach(tab => {
          tab.classList.remove("activeTab");
        });
        (e.target as HTMLTextAreaElement).classList.toggle("activeTab");
      });
    };

    onMounted(() => {
      devAdd();
      const tabs = cqueA(".tab");
      // variable shortcuts

      // functions
      cLenEqual(tabs, `${100 / tabs.length}%`, "width");
      // console.log(tabs[0]);
    });
    onUpdated(() => {
      devAdd();
    });
    ////////////////////////
    return {
      ss,
      openTab
    };
  }
};
